/**
 * BlueSolution Subscription Management API
 * Last changed: 2025-07-23T01:36:21+00:00
 *
 * OpenAPI spec version: 1.0.15
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { BssLegacyProductDiscount } from './bssLegacyProductDiscount';
import { CustomerCustomer } from './customerCustomer';
import { OneqrewModule } from './oneqrewModule';
import { OneqrewProductPackage } from './oneqrewProductPackage';
import { SubscriptionOrderContract } from './subscriptionOrderContract';

export interface CustomerOneqrewSubscription { 
    /**
     * Sum of all costs in EUR
     */
    monthlyCostSum?: number;
    /**
     * Amount of mobile devices the customer is paying for in their OneQrew subscription
     */
    amountDevices: number;
    /**
     * Amount of workspaces the customer is paying for in their OneQrew subscription
     */
    amountWorkspaces: number;
    packageType?: string;
    orderedAt?: string;
    endOfContract: string;
    startOfContract: string;
    isCloudVersion: boolean;
    amountClients: number;
    creationDate?: string;
    legacyProductDiscount?: BssLegacyProductDiscount;
    id?: number;
    productPackage?: OneqrewProductPackage;
    orderContract?: SubscriptionOrderContract;
    extraModules?: OneqrewModule[];
    customer?: CustomerCustomer;
    comment?: string;
}